/**
 * DeSight Shopify X | v1.0.0
 * Main JavaScript Entry Point
 * 
 * This file imports all JS modules and initializes the framework.
 * Compiled output: /assets/desight-shopify-x.js (IIFE format)
 */

import { checkCSSLoaded } from './utils/css-checker.js';
import { initShopify } from './shopify/init.js';
import { initCrossSelling } from './modules/cross-selling.js';
import { initLogoSlider } from './modules/logo-slider.js';

/**
 * Initialize DeSight Shopify X Framework
 */
function init() {
  const cssLoaded = checkCSSLoaded();

  console.log(`[DeSight Shopify X] JS loaded. CSS loaded: ${cssLoaded}`);

  // Initialize Shopify-specific functionality
  initShopify();

  // Initialize cross-selling functionality
  initCrossSelling();

  // Initialize logo slider functionality
  initLogoSlider();
}

// Run initialization when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

